import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchTotalMonitoredArtists } from "shared/service/RadarService";

export const getMonitoredData = createAsyncThunk(
  "monitoredData/Get",
  async () => {
    const data: any = await fetchTotalMonitoredArtists();

    return data.response;
  }
);

export type MonitoredDataState = {
  monitoredData: {
    totalMonitoredArtists: number;
    loading: boolean;
  };
};

export const monitoredDataSlice = createSlice({
  name: "monitoredData",
  initialState: {
    totalMonitoredArtists: 0,
    loading: true,
  },
  reducers: {},
  extraReducers: {
    [getMonitoredData.fulfilled.type]: (state, action) => {
      state.totalMonitoredArtists =
        action.payload?.totalMonitoredArtistsMillions;
      state.loading = false;
    },
    [getMonitoredData.pending.type]: (state) => {
      state.loading = true;
    },
  },
});

export default monitoredDataSlice.reducer;
